import Modal from "react-overlays/Modal";
import React, { useContext, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import dayjs from "dayjs";
import "dayjs/locale/it";
import Icon from "../components/icons";
import { useSetBooking } from "../hooks/useQueryCart";
import UserContext from "../context/user";
import { useNavigazione } from "../context/navigazione";
import { Link } from "react-router-dom";
import CustomSelect from "../components/custom-select";
import { getTicketOptions } from "../utils/utility";
import { ID_CONFERENZA, MAX_TICKET } from "../utils/constants";

const renderBackdrop = () => <div className="modal__external"></div>;

const BookingModal = ({ show, daycode, slot, hide, cart, free, eventType }) => {
  const day = dayjs(daycode, "YYYYMMDD").locale("it");
  const { titoli, book } = cart;
  const isPremium = slot.slot_premium;
  const allTitoli = (
    isPremium === "SI"
      ? titoli?.filter((item) => item.tck === "premium")
      : titoli
  )
    ?.filter(
      (item) =>
        (item.specie === "B" && item.data === daycode) || item.specie === "O",
    )
    .filter((item) => item.riduzione !== "OS" || eventType === ID_CONFERENZA);
  const book_slot = book?.find((s) => s.id_slot === slot.id_slot);
  const inCart = book_slot?.titoli.map((t) => t.codice);
  const { userProfile } = useContext(UserContext);
  const setBooking = useSetBooking();
  const { getPathByTemplate } = useNavigazione();
  const [placement, setPlacement] = useState("");
  const linkCarrello = getPathByTemplate("carrello");
  // const linkAddTitolo = getPathByTemplate("premium");

  const {
    register,
    handleSubmit,
    control,
    // reset,
    formState: { errors, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      codice: inCart,
      quantity: null,
      partecipanti: [
        {
          nome: userProfile.attributes?.name,
          cognome: userProfile.attributes?.family_name,
          telefono: userProfile.attributes?.["custom:mobile"],
        },
      ],
    },
  });

  const onSubmit = async (data) => {
    const codici = Array.isArray(data.codice)
      ? data.codice
      : [data.codice].filter(Boolean);
    const payload = {
      id_slot: slot.id_slot,
      titolo: !free ? codici : Array(data.quantity).fill("esente"),
    };
    console.log("payload", payload);
    try {
      await setBooking.mutateAsync(payload);
    } catch (error) {
      if (error?.code === "S7") {
        setPlacement("Disponibilità esaurita");
      } else if (error?.code === "S12") {
        setPlacement("Il titolo selezionato non è valido");
      } else if (error?.code === "S9") {
        setPlacement(
          "Superato il limite massimo di posti gratuiti per account/evento",
        );
      } else if (error?.code === "S4") {
        setPlacement("Titolo non riconosciuto");
      } else if (error?.code === "F5") {
        setPlacement("Prenotazione già presente");
      } else if (error?.code === "S14") {
        if (data.codice?.length > 1)
          setPlacement(
            "Hai già effettuato un acquisto in questo slot orario con uno dei titoli di accesso che hai selezionato. Riprova senza selezionarlo",
          );
        else
          setPlacement(
            "Hai già effettuato un acquisto con questo titolo in questo slot orario",
          );
      } else if (error?.code === "S15") {
        setPlacement(
          "Prenotazione non consentita, condivide data e ora con altra prenotazione per lo stesso titolo",
        );
      } else if (error?.code === "S16") {
        setPlacement("Limite di posti prenotabili raggiunto");
      } else if (error?.code === "F8") {
        setPlacement("Posto già prenotato in un precedente ordine");
      } else {
        setPlacement("Servizio attualmente non disponibile");
      }
    }
  };

  const onClose = () => {
    setBooking.reset();
    hide();
  };

  return (
    <Modal
      className="modal__internal d-flex flex-column"
      show={show}
      renderBackdrop={renderBackdrop}
    >
      <>
        <div className="modal__header">
          <h3>Partecipanti</h3>
        </div>
        <div className="d-flex flex-column flex-fill modal__body  min-h-0">
          {!free ? (
            <p>
              Puoi prenotare un posto per ogni titolo in tuo possesso. <br />
              Ricordati che le prenotazioni sono nominali e verranno associate
              ai soli titoli che selezionerai.
            </p>
          ) : (
            <p>
              Per gli eventi ad accesso gratuito puoi prenotare fino a{" "}
              {MAX_TICKET} posti
            </p>
          )}
          <p>
            Giorno della prenotazione:{" "}
            <strong>{day.format("dddd D MMMM")}</strong>
            <br />
            Orario: <strong>{slot.orario}</strong>
          </p>
          <form
            name="prenota"
            onSubmit={handleSubmit(onSubmit)}
            className="d-flex flex-column flex-fill my-3 min-h-0"
          >
            {!free ? (
              <div className="flex-fill form modal__form modal__form--scrollable min-h-0">
                <div className="mb-2">
                  {allTitoli?.length ? (
                    <strong>Titoli compatibili</strong>
                  ) : (
                    <p>
                      <strong>Attenzione</strong>: non ci risultano biglietti
                      compatibili nel tuo portafoglio titoli.
                      {/*  <br />
                      Se sei in possesso di titoli acquistati tramite call
                      center o Infopoint devi prima{" "}
                      <Link to={linkAddTitolo}>registrarli qui</Link>{" "} */}
                    </p>
                  )}
                </div>
                {allTitoli.map((item, index) => (
                  <div className="mb-1" key={index}>
                    <div className="d-flex gap-3">
                      <label className="d-flex gap-2">
                        <input
                          type="checkbox"
                          className="flex-shrink-0"
                          {...register(`codice`)}
                          value={item.barcode || item.codice}
                        ></input>
                        <span>
                          {item.specie === "B"
                            ? `Giornaliero${
                                item.riduzione === "OS" ? " Omaggio" : ""
                              }`
                            : item.tck === "premium"
                            ? "Premium"
                            : "Abbonamento"}
                          : {item.intestatario.nome} {item.intestatario.cognome}
                        </span>
                      </label>
                      <span className="badge flex-shrink-0 align-self-center">
                        {item.tck === "premium" ? "gratis" : "1 €"}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="mb-4">
                <div class="row">
                  <div class="col-12 col-md-6">
                    <Controller
                      name="quantity"
                      rules={{
                        validate: (value, values) => {
                          return !!value || "Quantità non specificata";
                        },
                      }}
                      control={control}
                      render={({ field: { onChange, value, ...other } }) => (
                        <CustomSelect
                          key="q-biglietti"
                          {...register(`quantity`)}
                          placeholder="Selezione il numero di biglietti"
                          className="form__select w-100 w-md-50"
                          options={getTicketOptions(MAX_TICKET)}
                          onChange={(e) => {
                            onChange(e?.value);
                          }}
                          onSubmit={() => void 0}
                          isSearchable={false}
                        />
                      )}
                    />
                  </div>
                </div>

                {errors?.["quantity"] && (
                  <p className="form__error align-self-lg-end mt-2">
                    ATTENZIONE: quantità non specificata
                  </p>
                )}
              </div>
            )}
            {setBooking.isSuccess && book_slot?.titoli.length && (
              <div className="mt-2">
                <Icon name="success" />{" "}
                <strong>
                  Prenotazione aggiunta. Per confermare le prenotazioni, anche
                  se hai un Abbonamento Premium,{" "}
                  <Link to={linkCarrello}>
                    <u>devi completare l'acquisto cliccando qui</u>
                  </Link>
                </strong>
              </div>
            )}
            {setBooking.isError && (
              <div className="mt-2">
                <Icon name="alert" /> <strong>{placement}</strong>
              </div>
            )}
            <div className="d-flex justify-content-between pt-3 gap-4">
              {(allTitoli.length || free) > 0 && (
                <button
                  className="btn btn--link"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}{" "}
                  {inCart?.length ? "Aggiorna" : "Aggiungi"}
                </button>
              )}

              <button className="btn btn--link" type="button" onClick={onClose}>
                Chiudi
              </button>
            </div>
          </form>
        </div>
      </>
    </Modal>
  );
};

export default BookingModal;
